import { motion } from "framer-motion";
import { ProductCard } from "@/components/ProductCard";
import { PRODUCTS } from "@/data/catalog";

export default function ProductsPage() {
  return (
    <section data-testid="products-page" className="py-14 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mb-12"
        >
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C05C46] mb-3">
            Our Range
          </p>
          <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-[#1c2826] mb-4">
            All Products
          </h1>
          <p className="text-base text-[#4B5563] leading-relaxed">
            Six certified Ayurvedic formulas — for digestion, joints, blood sugar and men's vitality.
            100% herbal, made in Jaipur, shipped all over India.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.09 }}
            >
              <ProductCard product={p} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
